// extracted by mini-css-extract-plugin
module.exports = {"radio":"changeDomains_radio__3bncg"};